import SuspenseLoader from 'components/SuspenseLoader';
import { ComponentType, lazy, Suspense } from 'react';
import { Navigate } from 'react-router-dom';

const Loader = (Component: ComponentType) => {
  const WithSuspense = (props: object) => (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );
  WithSuspense.displayName = 'WithSuspense';
  return WithSuspense;
};

const Role = Loader(lazy(() => import('content/accessControl/Roles')));
const SingleRole = Loader(
  lazy(() => import('content/accessControl/Roles/single'))
);

const accessControlRoutes = [
  {
    path: '',
    element: <Navigate to="/access-control" replace />,
  },
  {
    path: 'roles',
    children: [
      {
        path: '',
        element: <Navigate to="list" replace />,
      },
      {
        path: 'list',
        element: <Role />,
      },
      {
        path: 'single',
        children: [
          {
            path: '',
            element: <Navigate to="1" replace />,
          },
          {
            path: ':roleId',
            element: <SingleRole />,
          },
        ],
      },
    ],
  },
];

export default accessControlRoutes;
